import React, { useEffect, useRef } from "react";


export default function AreaCarousel() {
const carouselRef = useRef(null);

const areas = [
"Hazaribagh",
"Barhi",
"Barkagaon",
"Barkatha",
"Chauparan",
"Ichak",
"Katkamsandi",
"Katkamdag",
"Churchu",
"Padma",
"Bishnugarh",
"Tatijhariya",
"Daru",
"Koderma",
"Jhumri Telaiya",
"Domchanch",
"Markacho",
"Chandwara",
"Satgawan",
"Ramgarh",
"Patratu",
"Gola",
"Mandu",
"Chitarpur",
"Dulmi",
];

useEffect(() => {
const el = carouselRef.current;
let scrollAmount = 0;

const interval = setInterval(() => {
if (!el) return;
scrollAmount += 2;
if (scrollAmount >= el.scrollWidth - el.clientWidth) scrollAmount = 0;
el.scrollBy({ left: 2, behavior: 'smooth' });
}, 50);

return () => clearInterval(interval);
}, []);


const scrollLeft = () => {
carouselRef.current.scrollBy({ left: -200, behavior: "smooth" });
};


const scrollRight = () => {
carouselRef.current.scrollBy({ left: 200, behavior: "smooth" });
};
return (
<section className="area-section">
<h2>Our Service Areas</h2>
<div className="carousel-wrapper">
<button className="carousel-btn left" onClick={scrollLeft}>‹</button>


<div className="area-carousel" ref={carouselRef}>
{areas.map((a, i) => (
<span key={i} className="area-chip">{a}</span>
))}
</div>


<button className="carousel-btn right" onClick={scrollRight}>›</button>
</div>
</section>
);
}